import React, { useEffect } from 'react'
import { Helmet } from 'react-helmet'
import ProfileDesktop from '../components/faraaz/ProfileDesktop'
import ProfileMobile from '../components/faraaz/ProfileMobile'
import FrancisImg from '../assets/images/Francis.png'

const FrancisMari = () => {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Francis Mari | Administrative Executive - 800 Homes</title>
                <meta name="description" content="Meet Francis Mari, Administrative Executive at 800 Homes. Contact Francis for administrative support and inquiries." />
                <meta property="og:type" content="website" />
                <meta property="og:title" content="Francis Mari | Administrative Executive - 800 Homes" />
                <meta property="og:description" content="Meet Francis Mari, Administrative Executive at 800 Homes. Contact Francis for administrative support and inquiries." />
                <meta property="og:site_name" content="800 Homes" />
                <meta property="og:image" content="https://md.eacademe.org/images/team/francis-mari.webp" />
                <meta property="og:image:width" content="1200" />
                <meta property="og:image:height" content="630" />
                <meta property="og:image:secure_url" content="https://md.eacademe.org/images/team/francis-mari.webp" />
                <meta property="og:image:type" content="image/webp" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Francis Mari | Administrative Executive - 800 Homes" />
                <meta name="twitter:description" content="Meet Francis Mari, Administrative Executive at 800 Homes. Contact Francis for administrative support and inquiries." />
                <meta name="twitter:image" content="https://md.eacademe.org/images/team/francis-mari.webp" />
            </Helmet>

            <section id="website-responsive" className="d-none d-md-block">
                <ProfileDesktop
                    Image={FrancisImg}
                    Title="Francis Mari"
                    Designation="Administrative Executive"
                    PhoneNumberLink="+971585746637"
                    PhoneNumber="+971 58 574 6637"
                    WhatsappLink="971585746637"
                    Whatsapp="+971 58 574 6637"
                    Email="admin@800homes.ae"
                />
            </section>

            <section id="website-responsive" className="d-block d-md-none">
                <ProfileMobile
                    Image={FrancisImg}
                    Title="Francis Mari"
                    Designation="Administrative Executive"
                    PhoneNumberLink="+971585746637"
                    PhoneNumber="+971 58 574 6637"
                    WhatsappLink="971585746637"
                    Whatsapp="+971 58 574 6637"
                    Email="admin@800homes.ae"
                />
            </section>
        </>
    )
}

export default FrancisMari
